<script setup>
import { computed } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: () => '',
  },
  text: {
    type: String,
    default: () => '',
  },
  fontSize: {
    type: Number,
    default: () => 12,
  },
  bold: {
    type: Boolean,
    default: () => false,
  },
});

const fontStyle = computed(() => {
  return {
    fontSize: `${props.fontSize}px`,
    lineHeight: `${props.fontSize}px`,
    fontWeight: props.bold ? 500 : 400,
  };
});

</script>
<template>
  <div
    :class="[
      'status',
      't:truncate',
      `status_${type}`
    ]"
    :style="fontStyle"
  >
    {{ text }}
  </div>
</template>

<style lang="scss">
.status{
  display: inline-block;
  color: var(--text-body-secondary);
  white-space: nowrap;
  &_active,
  &_valid,
  &_ok,
  &_running,
  &_approved,
  &_paid,
  &_positive {
    color: var(--text-positive);
  }
  &_warning,
  &_expiring_soon,
  &_on_review,
  &_severe {
    color: var(--text-warning);
  }
  &_inactive,
  &_invalid,
  &_expired,
  &_paused,
  &_archived,
  &_declined,
  &_cancelled,
  &_for_rework,
  &_not_paid,
  &_negative {
    color: var(--text-negative);
  }
  &_new,
  &_draft,
  &_processing,
  &_in_hold,
  &_info{
    color: var(--text-info);
  }
}
</style>
